module.exports = __webpack_public_path__ + "static/media/sg12cr93.69bf7db2.png";